module.exports = __webpack_public_path__ + "static/media/Axle load.0a0651cf.JPG";